/**
 * SkipLink - Accessibility component for keyboard navigation
 *
 * Provides a skip-to-main-content link that is visually hidden but
 * becomes visible when focused. This helps keyboard users bypass
 * repetitive navigation elements.
 */

export interface SkipLinkProps {
  /** The ID of the element to skip to (without the #) */
  targetId: string;
  /** Custom label for the skip link */
  label?: string;
}

export function SkipLink({ targetId, label = "Skip to main content" }: SkipLinkProps) {
  return (
    // biome-ignore lint/plugin/no-anchor-element: Skip links are in-page anchors, not navigation
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-green-950 focus:px-4 focus:py-2 focus:text-white focus:outline-none"
    >
      {label}
    </a>
  );
}
